"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordComponent = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const input_1 = require("../../components/input/input");
const input_state_1 = require("../../components/input/input.state");
const input_state_group_1 = require("../../components/input/input.state.group");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const CSS = {
    container: 'c-ForgotPassword',
    heading: 'c-ForgotPassword__Heading',
    acceptButton: 'c-ForgotPassword__Accept',
};
(0, theme_1.addStyles)({
    [CSS.container]: {
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
    },
    [CSS.acceptButton]: {
        width: '300px',
    },
});
class ForgotPasswordComponent extends mithril_component_1.IMithrilStateComponent {
    constructor(ctrl) {
        super();
        this.email = new input_state_1.InputState(i18n_1.T.PASSWORD_FORGOT_EMAIL);
        this.form = new input_state_group_1.IkeInputStateGroup();
        this.ctrl = ctrl;
        this.form.add(this.email);
        this.email.isRequired = true;
        this.email.type = input_state_1.InputStateTypes.TEXT;
    }
    onCreate() {
        this.autorun((_) => this.validate());
    }
    get nodes() {
        return (0, mithril_1.m)('form', { className: CSS.container }, [
            (0, mithril_1.m)('h3', (0, i18n_1.Translate)(i18n_1.T.PASSWORD_FORGOT_TITLE)),
            this.ctrl.completedReset ? null : input_1.Input.view(this.email),
            this.ctrl.completedReset ? this.viewNextSteps() : this.viewAcceptButton(),
        ]);
    }
    viewAcceptButton() {
        const child = this.ctrl.loading ? spinner_1.Spinner.view() : (0, i18n_1.Translate)(i18n_1.T.PASSWORD_FORGOT_ACCEPT);
        const disabled = this.ctrl.loading || !this.form.canSubmit;
        return (0, mithril_1.m)('button', {
            className: `${CSS.acceptButton} mdl-button mdl-button--raised mdl-button--accent`,
            type: 'submit',
            onclick: this.submit,
            disabled,
        }, child);
    }
    viewNextSteps() {
        return (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.PASSWORD_FORGOT_SUCCESS));
    }
    submit() {
        if (!this.form.canSubmit) {
            services_1.Logger.error('Attempted to submit invalid form...');
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.ctrl.requestPasswordReset(this.email.value);
        // Don't submit form
        return false;
    }
    validate() {
        if (!this.ctrl.isValidEmail(this.email.value)) {
            this.email.setError(i18n_1.T.EMAIL_INVALID);
        }
        else {
            this.email.setError('');
        }
    }
}
exports.ForgotPasswordComponent = ForgotPasswordComponent;
tslib_1.__decorate([
    mobx_1.action.bound
], ForgotPasswordComponent.prototype, "submit", null);
//# sourceMappingURL=forgot.password.js.map